import React from "react";
import NFLookupEmptyForms from "../../../Shared/NewForms/NFLookupEmptyForms";

function AnalyticsTypeOfIncomeExpenseItemGenericSkeleton() {
  return (
    <>
      <NFLookupEmptyForms />
    </>
  );
}

export default AnalyticsTypeOfIncomeExpenseItemGenericSkeleton;
